import { render, staticRenderFns } from "./vkyc-landing.vue?vue&type=template&id=d1c2e7a8"
import script from "./vkyc-landing.vue?vue&type=script&lang=js"
export * from "./vkyc-landing.vue?vue&type=script&lang=js"
import style0 from "./vkyc-landing.vue?vue&type=style&index=0&id=d1c2e7a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports